// extracted by mini-css-extract-plugin
module.exports = {"questionNumber":"_1mhnLHJI8dgY1D8QP2xJrS"};